import * as React from 'react';
import { connect } from 'react-redux';
import {
  getAllTypes,
  getAllReportDrafts,
} from './redux-objects/actions';
import { ReportDraftInfo, IReportDraft } from './common/defaults';
import './assets/driverForm.scss';
import * as ReactDOM from 'react-dom';
import Form from '../../FormIO/presentation/FormWithValidations';

export interface IReportFormPropsFromState {
  types: any[];
  serviceURL: string;
  reportDrafts: ReportDraftInfo[];
  reportDraft: IReportDraft;
}

export interface IReportFormOwnProps {
  formId: string;
  data?: any;
  readOnly?: boolean;
  injectToSidebar?: any;
  onChange?: (formData: any) => void;
}

export interface IReportFormPropsFromActions {
  getAllTypes: (url: string) => void;
  getAllReportDrafts: (url: string) => Promise<void>;
  getReportDraft: (url: string, id: number) => Promise<void>;
}

export type IReportFormProps = IReportFormPropsFromActions &
  IReportFormPropsFromState &
  IReportFormOwnProps;

export class DriverForm extends React.Component<IReportFormProps, any> {
  private form: any;

  formLoaded = () => {
    const divToLoad = document.createElement('div');
    divToLoad.id = 'divSidebarAppend';
    document
      .getElementsByClassName('sidebar--wrapper')[0]
      .appendChild(divToLoad);
    ReactDOM.render(
      this.props.injectToSidebar,
      document.getElementById('divSidebarAppend')
    );
  };

  isFormValid = () => {
    return this.form.isValid();
  };

  render() {
    return (
      <div id='formio'>
        <div className='driverForm'>
          <Form
            formId={this.props.formId}
            ref={(form) => (this.form = form)}
            data={this.props.data}
            onRender={() => this.formLoaded()}
            onChange={this.props.onChange}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (reduxState: any) => {
  return {
    types: reduxState.LookupTypes.allTypes,
    serviceURL: reduxState.Application.backendURL,
  };
};

const mapDispatchToProps = {
  getAllTypes,
  getAllReportDrafts,
};

export default connect<any, IReportFormPropsFromActions>(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true }
)(DriverForm);
